import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

Sentry.init({
  dsn:
    'https://faf28e14c37b4ed59ec3291f758b4510@o109340.ingest.sentry.io/5420155',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: import.meta.env.VITE_API_DOMAIN
});

ReactDOM.render(<App />, document.getElementById('root'));
